import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './sections/Hero';
import Intro from './sections/Intro';
import GiftCard from './sections/GiftCard';
import Services from './sections/Services';
import Contact from './sections/Contact';

import masazas from './data/masazas';
import proceduras from './data/proceduras';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Intro />
        <GiftCard />

        <Services
          id="masazas"
          eyebrow="Masāžas"
          heading="Jūsu veselībai un skaistumam piedāvājam"
          items={masazas}
        />

        <Services
          id="proceduras"
          eyebrow="Procedūras"
          heading="Liekā svara un celulīta ārstēšanai tiek piedāvātas šādas procedūras"
          items={proceduras}
          tone="tint"
        />

        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
